function StrategicPlanning(props) {

    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">경영</h4>
                <h5 className="recruit_titleline_title">전략</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                    SBS의 비전은 &#39;TV를 넘어 세상을 새로운 기쁨으로 채우는 글로벌 문화 콘텐츠 기업&#39; 입니다.<br />
                    전략은 수많은 사업자들이 경쟁하며 시시각각 변화하고 있는 미디어 환경 속에서, 지상파방송사로 출발한 SBS가 이제 그 틀을 넘어<br />
                    경쟁력 있는 글로벌 문화 콘텐츠 기업이 되기 위해서는 무엇을 해야 하는 지 찾아내고 방향성을 제시하는 한편
                    이를 실현하기 위한 가장<br />효율적인 구조와 자원 배분 방안을 수립하는 직무입니다.<br /><br />
                    이러한 직무를 수행하는 데 있어 바탕이 되는 것은 콘텐츠와 미디어업계에 관한 관심과 열정입니다.<br />
                    SBS가 제작한 양질의 콘텐츠가 효과적으로 이용자에게 다가가도록 하여 그에 상응하는 충분한 수익을 가져오고, 이를 다시 재투자하여<br />
                    지속적으로 좋은 콘텐츠를 제작할 수 있는 구조를 만드는 일에서 의미와 보람을 찾을 수 있어야 합니다.<br />
                    전략 업무를 하는 사람은 현재 상황을 냉정하게 판단하고 이에 맞는 최선의 선택을 해야하지만 여기에 딱 떨어지는 정답은 없습니다.<br />
                    내외부의 상황을 분석할 수 있는 분석력과 인사이트, 불확실한 상황에서도 최선의 선택을 하기 위한 근거를 찾아낼 수 있는 논리적 사고력,<br />
                    이를 회사 구성원은 물론 외부를 대상으로도 설득할 수 있는 커뮤니케이션 능력 등이 중요합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                
                    <li className="recruit_subinfo_list_inner">
                        <ul className="recruit_subinfo_list">
                            <li className="recruit_subinfo_list_inner">비전 및 중장기 목표 설정 : 경영이념과 비전을 수립하여 SBS가 나아가야 할 방향을 설정합니다.</li>
                            <li className="recruit_subinfo_list_inner">미래 성장전략 수립 : 미디어 시장을 분석하고, 시장의 변화에 맞춰 인수합병을 포함한 신성장동력을 발굴합니다.</li>
                            <li className="recruit_subinfo_list_inner">디지털 플랫폼 비즈니스 전략 수립 : 웨이브/SMR/유튜브/홈페이지 등 디지털 플랫폼에 대한 전략과 글로벌OTT 대응 전략 등을<br /> 수립합니다.</li>
                            <li className="recruit_subinfo_list_inner">자회사/계열회사 관련 업무 : 그룹 내 자회사/계열회사 간 전략 및 사업구조 조정 등을 담당합니다.</li>
                            <li className="recruit_subinfo_list_inner">방송기술/인프라 전략 수립 : 기술 부문 중장기 전략을 수립하고, 인프라 등에 대한 투자 계획을 검토합니다. </li>
                        </ul>
                    </li>
                

            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    전략 업무를 통해 여러분은 주로 새롭게 수익을 창출해낼 수 있는 사업 구조에 대해 고민하게 될 것입니다.<br />
                    따라서 업무 연관성을 따지자면 가장 밀접한 것은 미디어사업 영역이며,
                    디지털 광고 부문 등을 생각하면 광범위하게는 광고/마케팅 영역 역시 관련이 있다고 볼 수 있습니다.
                    실제 사업을 수행해보지 않고 전략을 수립하는 것은 한계가 있으므로 사업/광고/마케팅 영역 등을 전략<br />
                    업무의 선행/후행 커리어로 생각할 수 있을 것입니다.<br /><br />
                    연관부서들을 경험하더라도 결국 장기적으로 전략 업무를 계속한다는 것은 어떤 전문성을 갖게 되는 것일까 라는 의문이 드실 수 있습니다.
                    인사나 재무 업무를 10년 이상하면 다른 회사에서도 유사 업무를 할 수 있겠지만, 전략이라는 업무는 분야가 달라지거나 법인이 달라지면 그 성격이 아예 달라질 수 있습니다.
                    현재 미디어업계의 범위는, 그리고 SBS가 협력해야 할 대상은 매우 광범위합니다. 다른 방송사, 통신사,<br />가전사는 물론이고 유통사나 신생 스타트업과도 협업할 일이 있습니다.
                    전략 업무를 하면서 여러분은 다양한 분야에서 새로운 밸류를 창출하려는 사람들과 만나 이야기하고 때로는 이를 실행에 옮길 수도 있습니다.
                    아직 가능성만 보이는 사업을 직접 추진해보거나,
                    다양한 파트너들과 새로운 BM을 만들고 지분을 투자하는 등 새로운 형태의 협업을 하는 경험은 지금처럼 빠르게 변화하는 비즈니스 환경에서 여러분 개인에게도 분명 자산이 될 것입니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS 미디어전략팀에서 플랫폼전략을 담당하고 있는 이용정입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">전략 업무를 하게 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    저는 2008년에 SBS에 입사했습니다. 입사 당시부터 앞으로의 콘텐츠 소비 방식은 지상파방송이나
                    케이블방송 같은 틀을 넘어서 계속 변화할 것으로 생각했고, 그 속에서 제가 할 수 있는 역할을 찾고
                    싶었습니다. 미디어 시장이 어떻게 변하고 있고 SBS는 어떻게 하면 지속해서 좋은<br />콘텐츠를 제작할 수
                    있는 구조를 만들어갈 수 있을까 라는 것이 일관된 관심사였고, 입사 이후 예산, 저작권, 계열사 콘텐츠
                    유통 계약, 방송정책 등 다양한 업무를 경험했는데 큰 틀에서는 모두 전략과 관련된 부서였습니다.
                    2020년 말부터 현재의 미디어전략팀에 오게 되었으며,<br />현재 플랫폼 전략이라는 큰 틀 하에서 유튜브와
                    SMR, OTT, FAST 등과 관련된 일을 하고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    TV플러스라는 플랫폼에서 2021년 12월 29일부터 SBS 채널들이 서비스를 개시했을 때입니다. FAST라는
                    사업모델이 국내에서는 아직 초창기이고 갈 길이 멀긴 합니다만, 채널 송출을 위한 인프라와 회선, 장비부터
                    시작해서 콘텐츠 편성, 마케팅 이미지 등 처음부터 모든 것을 챙겨서<br />서비스를 개시하게 되니 뿌듯했습니다.
                    물론 사내에서 여러 부서가 모두 도와주시지 않았다면 불가능했을 것입니다. 최근 입사 동기인<br />시사교양PD 한 분이
                    OTT오리지널로 진행하고 싶은 기획안이 있다고 해서 투자 제안을 진행하여 최종 투자 결정이 되었을 때도 보람을 느꼈습니다.<br />
                    물론 기획안 자체가 경쟁력이 있어서 가능한 일이었겠지만, 신입 사원 교육 마지막 날인가 제가 입사 동기들에게 너희는 잘 만들기만 해라,<br />
                    내가 잘 팔고 투자도 많이 받아오겠다고 이야기했던 기억도 나고 그랬습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    방송사 특유의 문화, 그리고 전체 직원 숫자 자체가 많지 않다는 점, 이런 특징들 때문인지
                    SBS는 생각보다 굉장히 저연차의 여러분에게 많은 일들을 맡길 것입니다. 식당에 비유하자면, 대기업은 1년 내내
                    양파만 깔 텐데, 여기서는 메뉴 2~3개 정도는 처음부터 책임지고 만들게 한다고 표현할 수 있을 것 같습니다. <br /><br />
                    그리고 정해진 시스템보다는 유연성이 큰 조직으로, 여러 사람을 설득할 수 있고 뜻을 같이하는 사람들이 모이면 안 될 것 같은 일을 가능하게 할 수 있는 곳이기도 합니다.
                    미디어업계에 대한 열정과 도전의식과 아이디어가 넘쳐나고,
                    길이 없으면 만들어서라도 가겠다는 적극성을 가진 지원자라면 SBS에 입사하여 충분히 꿈을 펼치실 수 있을 것입니다.
                </p>
            </div>
        </div>);
}

export default StrategicPlanning;

